import StatCard from '../../dashboard/components/StatCard';
import type { AdminIntegrationStats } from '../../../domain/superadmin/types';

interface IntegrationStatsCardsProps {
    stats: AdminIntegrationStats;
}

const formatNumber = (value: number) => value.toLocaleString('pt-BR');

export function IntegrationStatsCards({ stats }: IntegrationStatsCardsProps) {
    return (
        <section aria-label="Indicadores" className="mb-s5 grid grid-cols-1 gap-s3 sm:grid-cols-2 lg:grid-cols-4">
            <StatCard
                title="Total"
                value={formatNumber(stats.total)}
                change={0}
                period="integrações"
                baseValue="-"
                icon="link"
                accent="brand"
            />
            <StatCard
                title="Conectados"
                value={formatNumber(stats.connected)}
                change={0}
                period="ativos"
                baseValue="-"
                icon="check"
                accent="success"
            />
            <StatCard
                title="Desconectados"
                value={formatNumber(stats.disconnected)}
                change={0}
                period="offline"
                baseValue="-"
                icon="unlink"
            />
            <StatCard
                title="Expirando (≤7d)"
                value={formatNumber(stats.expiringSoon)}
                change={0}
                period="atenção"
                baseValue="-"
                icon="clock"
            />
        </section>
    );
}
